module.exports = __webpack_public_path__ + "static/media/team2.19870257.jpg";